import React, { useEffect, useState, useCallback } from 'react'
import { Box, Typography, Divider, Paper, Grid, SpeedDial, Card, CardContent, CardActions, IconButton } from '@mui/material';
import Modal from 'components/Modal';
import CancelIcon from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';
import { useSnackbar } from 'notistack';
import AddCoupon from './Add';
import useConfirm from 'core/hooks/useConfirm';
import { getCoupons, getCouponDetails, deleteCoupon } from 'services/coupons';

const Coupons = () => {

  const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [coupons, setCoupons] = useState([]);
  const [couponDetails, setCouponDetails] = useState(null);
  const confirm = useConfirm();

  useEffect(() => {
    getAllCoupons();
  }, []);

  const onModalClose = useCallback(
    () => {
      setOpenModal(false);
    },
    [setOpenModal],
  )

  function getAllCoupons() {
    getCoupons().then(({response, error}) => {
      if(response){
        setCoupons([...response]);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const onCouponAdded = useCallback(
    () => {
      getAllCoupons();
      setOpenModal(false);
      setCouponDetails(null)
    },
    [],
  );

  const onCouponDelete = (e,id) => {
    e.stopPropagation();
    setCouponDetails(null);
    if(id) {
      confirm({ title: 'Delete Coupon?', description: 'Are you sure you want to delete this coupon?' })
    .then(() => { 
      deleteCouponData(id);
    })
    }
  };

  const deleteCouponData = (id) => {
    deleteCoupon({id}).then(({response, error}) => {
      if(response){
        enqueueSnackbar((response?.message || "Coupon deleted successfully"), {variant: 'success'});
        getAllCoupons();
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const onAddCouponClick = (e) => {
    setCouponDetails(null)
    setOpenModal(true);
  };

  const onCardClick = (e,id) => {
    e.preventDefault();
    getCouponDetails({id}).then(({response, error}) => {
      if(response){
        setCouponDetails({...response})
        setOpenModal(true);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Coupons
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container columnSpacing={4} rowSpacing={2} >
          {coupons.map((coupon, index) => (
            <Grid className='coupon-card-container' item xs={10} sm={6} md={6} xl={3} lg={4} key={index} >
              <Card className="coupon-card" sx={{ px:2, py: 1, height: '180px', position: 'relative', boxShadow: 'none', cursor: 'pointer', borderRadius: '10px' }} onClick={(e) => onCardClick(e,coupon?.id)}>
                <CardContent>
                  <Typography gutterBottom variant="h4" component="div"  sx={{p: 0, m:0, lineHeight: 1, color: '#fcfcfc'}}>
                    -{coupon.discountPercent} %
                  </Typography>
                  <Typography gutterBottom variant="h6" component="div"  sx={{color: '#fcfcfc', textAlign: 'right'}}>
                    {coupon.code}
                  </Typography>
                  <Divider sx={{color : '#fff', borderStyle: 'dashed', borderColor: '#fff', position: 'absolute',top: '90px',left: 0,right: 0,margin: '0 22px'}} />
                  <Box sx={{position: 'absolute',  px:2, py: 1,  bottom: 0, left: 0, right: 0 }}>
                    <Typography component="div" variant="subtitle1" color="text.secondary" sx={{ color : '#fff', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden'}}> 
                      {coupon.description}
                    </Typography>
                    <Typography component="div" variant="subtitle2" color="text.secondary" sx={{ color: '#784900', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden'}}> 
                      Valid till {coupon.validityEndDate}
                    </Typography>
                  </Box>
                </CardContent>
                <CardActions  sx={{ position: 'absolute', top: 0, right: 0}}>
                  <IconButton variant="raised"  onClick={(e) => onCouponDelete(e, coupon?.id)}
                  >
                    <CancelIcon sx={{color: '#fcfcfc'}} />
                  </IconButton>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <SpeedDial
        onClick={onAddCouponClick}
        ariaLabel="Add Coupon"
        sx={{ position: 'absolute', bottom: 75, right: 75 }}
        icon={<AddIcon />}
      />
      <Modal maxWidth={"sm"} open={openModal} onModalClose={onModalClose} title={couponDetails ? 'Update Coupon' : 'Add Coupon'}>
        <AddCoupon onCouponAdded={onCouponAdded} couponDetails={couponDetails} />
      </Modal>
    </Paper>
  );
}
 
export default React.memo(Coupons);
